import { render } from "./AccountSettingsView.vue?vue&type=template&id=10ade82c&scoped=true"
import script from "./AccountSettingsView.vue?vue&type=script&lang=js"
export * from "./AccountSettingsView.vue?vue&type=script&lang=js"

import "./AccountSettingsView.vue?vue&type=style&index=0&id=10ade82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ade82c"]])

export default __exports__